import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActionState, ComponentState, OutGoingLink, SelectedValue } from './shared/model';
import { UbsComponentStoreService } from './ubs-component-store.service';

@Injectable({
  providedIn: 'root'
})
export class UpdateComponentStoreService {
  outGoingLink = new BehaviorSubject<OutGoingLink>(null);
  selectedValue = new BehaviorSubject<SelectedValue>(null);
  constructor(private componentStore:UbsComponentStoreService ) { }

  setStoreState(componentState:ComponentState):void{
    console.log({ComponentState:componentState});
    this.componentStore.setState(componentState);
  }

  setOutGoingLink(outGoingLink:OutGoingLink):void{
    console.log({OutgoingLinkSubscription:outGoingLink})
    this.outGoingLink.next(outGoingLink);
  }
  getOutGoingLink():Observable<OutGoingLink>{
    return this.outGoingLink.asObservable()
  }

  setSelectedValue(selectedValue:SelectedValue):void{
    this.selectedValue.next(selectedValue);
  }

  getSelectedValue():Observable<SelectedValue>{
    return this.selectedValue.asObservable();
  }

  //this.componentStore.updateAction(ActionState.VIEW);
  //this.componentStore.updateSelectedValue(selectedValue);

  handleMenuItemSelected(selectedValue:SelectedValue){
    console.log({TrackSelectedValue:"ListContainerComponent",value:selectedValue});
    console.log({"TrackHyperLink":"handleHyperLinkSelected","ListContainerComponentValue:":selectedValue});
    console.log("SelectedValue in handleHyperLinkSelected",selectedValue);
    let event = selectedValue.event;
    console.log(event)
    switch (event) {
      case ActionState.VIEW:
        this.componentStore.updateAction(ActionState.VIEW);
        break;
      case ActionState.LIST:
        this.componentStore.updateAction(ActionState.LIST);
        /* let hyperlinkListForm = this.listForms.find(listForm => listForm.listFormName == selectedValue.data.formData.formName);
        if(hyperlinkListForm != undefined){
          this.listForm = hyperlinkListForm;
          if(this.listForm.cardMode != undefined){
            this.cardMode = this.listForm.cardMode;
          }
        }
        console.log({HyperlinkListForm:hyperlinkListForm,cardMode:this.cardMode});
        this.setActiveLevel(selectedValue.data.formData.formName,this.listForms);
        this.remoteFormData = {
          formData:selectedValue.data["formData"],
          appContext:selectedValue.data["appContext"],
          parameters:selectedValue.data["parameters"]
        }
        console.log({RemoteFormDataHandleHyperLink:this.remoteFormData});
        this.componentStore.componentConfig$
        .subscribe((componentConfig:ComponentConfig) => {
          if(componentConfig !=null){
            this.setFieldsFromListForm(this.componentConfig,selectedValue.type);
            this.componentStore.updateAction(ActionState.LIST);
          }
        }); */
        break;
      case ActionState.DELETE:
        console.log({deleteState:event});        
/*         this.remoteFormData.formData = selectedValue.data["formData"];
        this.remoteFormData["parameters"] = selectedValue.data["parameters"]; */
        break;
      case ActionState.EDIT:
        console.log({"TrackEdit":event,"component":"UpdateComponentStoreService"});
        this.componentStore.updateAction(ActionState.EDIT);
        break;
      case ActionState.ADD:
        /* this.componentStore.selectedValue$.subscribe((data) => {console.log("SelectedValue in Add",data);})
        this.remoteFormData.formData = selectedValue.data["formData"];
        this.remoteFormData["parameters"] = selectedValue.data["parameters"];
        console.log({remoteFormData:this.remoteFormData}); */
        this.componentStore.updateAction(ActionState.ADD);
        break;
      case ActionState.LINK:
        console.log({"linkingThings":event,"component":"ListContainerComponent"});
        this.componentStore.outGoingLink$.subscribe(data => {
          console.log({OutGoingLink:data});
        })
      default:
        break;
    }
    this.componentStore.updateSelectedValue(selectedValue);
    
  }

}
